import React from "react";
import { AbstractApplicationProvider } from "app/entities/form-controller/abstract";
import {
  createJobDescriptionRequestStore,
  JobDescriptionRequestParams,
} from "app/features/job-description-request";
import { JobDescriptionRequestForm } from "app/features/job-description-request/ui/job-description-request-form";
import { useParams } from "react-router-dom";
import { useQueryParams } from "app/shared/hooks/use-query-params-custom";

export const JobDescriptionFormWidget = ({
  onSubmit,
  onStatusChange,
}: {
  onSubmit?: (fields: Record<string, string>) => void;
  onStatusChange?: (status: string) => void;
}) => {
  const { entityId = "new" } = useParams();
  const [query] = useQueryParams<JobDescriptionRequestParams>();
  const defaultValue =
    entityId === "new" ? { positionGroup: { id: query.positionGroupId } } : {};

  return (
    <AbstractApplicationProvider
      createStore={() =>
        createJobDescriptionRequestStore(entityId, defaultValue)
      }
    >
      <JobDescriptionRequestForm
        onSubmit={onSubmit}
        onStatusChange={onStatusChange}
      />
    </AbstractApplicationProvider>
  );
};
